import { type IManufacturer } from '@mahawi/eshop-common/src/types';
import { Select } from 'antd';
import React from 'react';

import { getFilterOption, getFilterSort } from '../../fragments/select-filter';

export const toOperatorOptions = (
  operators: IManufacturer[] | undefined,
): { label: string; value: string }[] =>
  (operators ?? []).map((operator: IManufacturer) => ({
    label: `${operator.name} (${operator.countryType.isoCode2})`,
    value: operator.uuid,
  }));

function OperatorSelect({
  operators,
  value,
  onChange,
  disabled,
  placeholder,
}: {
  operators: IManufacturer[] | undefined;
  value?: string | null;
  onChange?: (value: string | null) => void;
  disabled?: boolean;
  placeholder: string;
}): React.ReactElement {
  return (
    <Select
      value={value ?? undefined}
      onChange={(next: string | undefined): void => onChange?.(next ?? null)}
      allowClear
      placeholder={placeholder}
      disabled={disabled}
      showSearch={{
        filterOption: getFilterOption,
        filterSort: getFilterSort,
      }}
      options={toOperatorOptions(operators)}
    />
  );
}

export default OperatorSelect;
